var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('br'),_vm._m(0),_c('br'),_c('CarouselRock'),_c('br'),_c('DiscograficasRock')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('strong',[_vm._v("ROCK RECORDS")])])
}]

export { render, staticRenderFns }